module.exports = "pegasus/assets/themelp1/ebook/102.png";